module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kb-Lb.b1c4c675.png";